import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import { getAccessIcons, getCreateLocIcon } from '../accessIcons';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui';

const border = '1px solid #D3D3D3';
const styles = {
  cell: { padding: 0, textAlign: 'center', overflow: 'visible', borderLeft: border },
};

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const AccessLevel = props => {
  const {
    userId, corporateAccess, locAccess, isSingleLoc, companyType, adminTeam, contractingTeam, isAccom,
  } = props;
  const isBuyer = companyType === 'Contractor';
  const isBuyerOrSingleLoc = isBuyer || isSingleLoc;
  const isMultiLoc = !isBuyerOrSingleLoc;
  const isOnAdminTeam = !isNilOrEmpty(adminTeam.filter(obj => obj.userId === userId));
  const isOnContractingTeam = !isNilOrEmpty(contractingTeam.filter(obj => obj.userId === userId));
  const userTeams = [];
  if (isOnAdminTeam) userTeams.push('admin');
  if (isOnContractingTeam) userTeams.push('contracting');
  const alphaSortLocs = (locAccess || [])
    .filter(o => !o.isHidden && !o.is_archived)
    .sort((a, b) => {
      if (a.property_name > b.property_name) return 1;
      if (b.property_name > a.property_name) return -1;
      return 0;
    });
  /*
  * Buyer:         Team(s) | Profile | User Management | Contracting
  * Single Loc:    Team(s) | Profile | User Management | Contracting
  * Multi Loc:     Location | Team(s) | Profile | User Management | Contracting
  *   (Multi Loc will include "Corporate Profile")
  */
  return (
    <div>
      <div style={{ fontSize: '24px', fontWeight: 400, marginTop: '4px', paddingBottom: '12px', borderBottom: '1px solid #e6e9ec' }}>
        Access Level&nbsp;
        <small style={{ fontSize: '12px' }}>(Note: You cannot edit your own access level)</small>
      </div>
      <div>
        <Table fixedHeader style={{ maxHeight: '400px' }}>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            <TableRow>
              {
                isMultiLoc && (
                  <TableHeaderColumn
                    colSpan={6}
                    style={styles.cell}
                  >
                    {isAccom ? 'Property' : 'Location'}
                  </TableHeaderColumn>)
              }
              <TableHeaderColumn
                colSpan={3}
                style={styles.cell}
              >
                Team(s)
              </TableHeaderColumn>
              <TableHeaderColumn
                colSpan={3}
                style={styles.cell}
              >
                Profile
              </TableHeaderColumn>
              <TableHeaderColumn
                colSpan={3}
                style={styles.cell}
              >
                <div style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>User Management</div>
              </TableHeaderColumn>
              <TableHeaderColumn
                colSpan={3}
                style={{
                  ...styles.cell,
                  borderRight: border,
                }}
              >
                Contracting
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} style={{ width: '99%' }}>
            {
              isMultiLoc && (<TableRow style={{ borderLeft: border, borderRight: border }}>
                <TableRowColumn
                  colSpan={6}
                >
                  Corporate Profile
                </TableRowColumn>
                <TableRowColumn colSpan={3}/>
                <TableRowColumn
                  colSpan={3}
                  style={{ overflow: 'visible', textAlign: 'center' }}
                >
                  {getCreateLocIcon(corporateAccess || [])}
                </TableRowColumn>
                <TableRowColumn
                  colSpan={6}
                />
              </TableRow>)
            }
            {
              alphaSortLocs.map((loc, i) => {
                return (
                  <TableRow key={i} style={{ borderBottom: border }}>
                    {isMultiLoc && <TableRowColumn
                      colSpan={6}
                      style={{ borderLeft: border }}
                    >
                      {loc.property_name}
                    </TableRowColumn>}
                    <TableRowColumn colSpan={3} style={styles.cell}>
                      {loc.teams.sort((a, b) => {
                        if (a > b) return 1;
                        if (b > a) return -1;
                        return 0;
                      }).join(', ')}
                    </TableRowColumn>
                    <TableRowColumn
                      colSpan={3}
                      style={styles.cell}
                    >
                      {
                        isBuyerOrSingleLoc
                          ? getCreateLocIcon(corporateAccess || [])
                          : getAccessIcons(loc.profile)
                      }
                    </TableRowColumn>
                    <TableRowColumn
                      colSpan={3}
                      style={styles.cell}
                    >
                      {getAccessIcons(loc.admin)}
                    </TableRowColumn>
                    <TableRowColumn
                      colSpan={3}
                      style={{
                        ...styles.cell,
                        borderRight: border,
                      }}
                    >
                      {getAccessIcons(loc.contracting)}
                    </TableRowColumn>
                  </TableRow>
                );
              })
            }
        </TableBody>
        </Table>
      </div>
    </div>
  );
};

AccessLevel.propTypes = {
  corporateAccess: PropTypes.array,
  locAccess: PropTypes.array,
  isSingleLoc: PropTypes.bool,
  companyType: PropTypes.string,
  userId: PropTypes.string,
  adminTeam: PropTypes.array,
  contractingTeam: PropTypes.array,
  isAccom: PropTypes.bool,
};

const mapStateToProps = ({ user, userManagement }) => ({
  companyType: user.getIn(['user', 'type']),
  corporateAccess: user.get('corporateAccess'),
  locAccess: user.get('locAccess'),
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
  adminTeam: userManagement.get('admin').toJS(),
  contractingTeam: userManagement.get('contracting').toJS(),
  userId: user.get('id'),
  isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
});

export default connect(mapStateToProps)(AccessLevel);



// WEBPACK FOOTER //
// ./src/app/components/settings/mySettings/accessLevel.jsx